import { gql } from '@apollo/client';

export const fetchDistrictsForLeadershipQuery = gql`
  query getDistrictsForLeadership($roles: [String]!, $rotaryYear: Int!) {
    getDistrictsForLeadership(roles: $roles, rotaryYear: $rotaryYear) {
      error
      districts {
        id
        riDistrictId
        isHomeDistrict
        zone
      }
    }
  }
`;
